import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function getList(params) {
  return request({
    url: '/bpm/users',
    method: 'get',
    params
  })
}

export function createUser(data) {
  return request({
    url: '/bpm/users',
    method: 'post',
    data
  })
}

export function deleteUsers(data) {
  return request({
    url: '/bpm/users',
    method: 'delete',
    data
  })
}

export function updateUser(id, data) {
  return request({
    url: `/bpm/users/${id}`,
    method: 'put',
    data
  })
}

export function getUser(id) {
  return request({
    url: `/bpm/users/${id}`,
    method: 'get'
  })
}

export function resetUserPassword(id, data) {
  return request({
    url: `/bpm/users/${id}/password`,
    method: 'put',
    data
  })
}

export function getRoleList(params) {
  return request({
    url: '/bpm/roles',
    method: 'get',
    params
  })
}
